import Dialog from '@material-ui/core/Dialog';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import styled from 'styled-components';
import ProceduresContext from '../procedures/ProceduresContext';
import CategoriesForm from './CategoriesForm';
import CategoriesAdd from './CategoriesAdd';
import Divider from '@material-ui/core/Divider';
import { Formik, Form, FieldArray } from 'formik';
import CategoryItem from './CategoryItem';


// const Container = styled.div`
//     min-width:690px;
//     display:flex;
//     flex-direction:column;
//     padding-bottom:40px;
//     min-height:600px;
//     align-items:space-between;
// `;


const Container = styled.div`
    min-width:690px;
    display:flex;
    flex-direction:column;
    align-items:space-between;
`;


const ContainerHeader = styled.div`
    width:100%;
    color: white;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    line-height: 24px;
    text-align: left;
    padding:20px;
    height:80px;
    background-color:RGB(48, 74, 87);
    display:flex;
    align-items:center;
`;

const ContainerSteps = styled.div`
`;





class CategoriesDialog extends React.Component {

    static contextType = ProceduresContext;


    render() {
        let categories = this.context.selectedFunctionDetails ? this.context.selectedFunctionDetails.categories ? this.context.selectedFunctionDetails.categories : [] : [];
        categories = categories.filter(cateogry => cateogry.functionId);
        return (
            this.context.categoriesDialogOpen ?
                <Formik
                    enableReinitialize
                    initialValues={{ categories, editableIndex: null }}
                    onSubmit={values =>
                        setTimeout(() => {
                            alert(JSON.stringify(values, null, 2));
                        }, 500)
                    }
                    render={(formProps) => (
                        <Form>
                            <Dialog maxWidth='xl' open={true}>
                                <Container>
                                    <ContainerHeader>Add/Edit Procedure Categories</ContainerHeader>
                                    <FieldArray
                                        name="categories"
                                        render={arrayHelpers => (
                                            <>
                                                <CategoriesAdd formProps={formProps} arrayHelpers={arrayHelpers} />
                                                <ContainerSteps>
                                                    <CategoriesForm context={this.context} formProps={formProps} />
                                                </ContainerSteps>
                                            </>
                                        )}
                                    />
                                </Container>
                            </Dialog>
                        </Form>
                    )}
                />
                :
                null
        )
    }

}

export default CategoriesDialog;